import React, { useMemo } from "react";
import { Select } from "antd";
import { IoIosArrowDown } from "react-icons/io";

const LanguageFieldNew = ({
  language,
  register,
  errors,
  setValue,
  getValues,
  trigger,
  labelTxt = "Languages Known",
  registerContent = "languages_known",
  placeholder = "Select your known languages",
  multiSelectClassName = "dynamic-languages",
  multiSelectWrapperClassName = "col-md-6",
  labelClassName = "",
  validation = "known Languages",
  selectedLang = [],
  selectedDataIdList = [],
}) => {
  const memoizedOptions = useMemo(() => {
    return selectedDataIdList?.length
      ? language.filter(
          ({ active = null, _id }) =>
            active === null || active || selectedDataIdList.includes(_id),
        )
      : language;
  }, [language, selectedDataIdList]);

  const handleChange = (selectedValues) => {
    const formattedValues = selectedValues.map((value) => ({
      [`${registerContent}.${value}`]: value,
      _id: value,
      type: value,
    }));
    setValue(registerContent, formattedValues);
    trigger();
  };

  // Get current values for the Select component
  const currentValues = getValues()?.[registerContent] || [];
  const selectedValues = Array.isArray(currentValues)
    ? currentValues.map((item) => item?._id || item).filter(Boolean)
    : [];

  return (
    <div
      className={`col-12 ${multiSelectWrapperClassName} mb-40 position-relative`}
    >
      <label className={`form-label ${labelClassName}`}>
        {labelTxt} <span className="star">*</span>
      </label>
      <Select
        mode="multiple"
        style={{ width: "100%" }}
        placeholder={placeholder}
        value={selectedValues}
        onChange={handleChange}
        options={memoizedOptions.map((lang) => ({
          label: lang.type,
          value: lang._id,
        }))}
        suffixIcon={<IoIosArrowDown size={18} />}
        className={multiSelectClassName}
        maxTagCount={4}
        maxTagTextLength={10}
      />
      {!selectedValues.length && (
        <div className="invalid-feedback d-block">
          Please provide a {validation}
        </div>
      )}
    </div>
  );
};

export default LanguageFieldNew;
